import { render, staticRenderFns } from "./ProfitDetail.vue?vue&type=template&id=e5ddcee4&scoped=true&"
import script from "./ProfitDetail.vue?vue&type=script&lang=js&"
export * from "./ProfitDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProfitDetail.vue?vue&type=style&index=0&id=e5ddcee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ddcee4",
  null
  
)

export default component.exports